import { message } from "antd";
import { call, put, takeLatest, all, select } from "redux-saga/effects";
import { fetchQuickCodesAPI, addUpdateQuickCodesAPI, fetchQuickCodesbyIdAPI } from '../../../services/quickcodes-service';
import {
    FETCH_QUICK_CODES, FETCH_QUICK_CODES_START, FETCH_QUICK_CODES_SUCCESS, FETCH_QUICK_CODES_ERROR, SET_QUICK_CODES_PAGINATION, ADD_UPDATE_QUICK_CODE, ADD_UPDATE_QUICK_CODE_START, ADD_UPDATE_QUICK_CODE_SUCCESS,
    ADD_UPDATE_QUICK_CODE_ERROR, FETCH_QUICK_CODES_BY_ID, FETCH_FETCH_QUICK_CODES_BY_ID_START, FETCH_FETCH_QUICK_CODES_BY_ID_SUCCESS,
    FETCH_FETCH_QUICK_CODES_BY_ID_ERROR
} from '../../actions/receptionist/quickCodesAction';

function* fetchQuickCodes({ payload  }) {
    const defaultPayload = {
        searchText: "",
        page: 1,
        size: 20
    };
    const requestPayload = payload ? { ...defaultPayload, ...payload } : defaultPayload;

    try {
        yield put({ type: FETCH_QUICK_CODES_START })
        const response = yield call(fetchQuickCodesAPI, requestPayload);

        if (response.success) {
            const pagination = {
                currentPage: requestPayload.page,
                pageSize: requestPayload.size,
                totalPages: response.data.totalPages,
                totalItems: response.data.totalCount,
            }
            yield put({ type: FETCH_QUICK_CODES_SUCCESS, quickcodes: [...response.data.data] })
            yield put({ type: SET_QUICK_CODES_PAGINATION, pagination: pagination });
        } else {
            yield put({ type: FETCH_QUICK_CODES_ERROR, error: response.error })
        }
    } catch (error) {
        yield put({ type: FETCH_QUICK_CODES_ERROR, error })
    }
}

function* addUpdateQuickCodes({ quickcode }) {

    try {
        yield put({ type: ADD_UPDATE_QUICK_CODE_START })
        const response = yield call(addUpdateQuickCodesAPI, quickcode);


        if (response.success) {
            yield put({ type: ADD_UPDATE_QUICK_CODE_SUCCESS, quickcode: response.quickcode })
            if (quickcode.quickcodeId === 0) {
                message.success('Quickcode created successfully!');
            } else {
                message.success('Quickcode updated successfully!');
            }


        } else {
            yield put({ type: ADD_UPDATE_QUICK_CODE_ERROR, error: response.error })

            message.error('Failed to update Quickcode!');
        }

    } catch (error) {
        message.error('Failed to update Quickcode!');
        yield put({ type: ADD_UPDATE_QUICK_CODE_ERROR, error: error })


    }
}

function* fetchQuickCodesbyId({ payload }) {


    try {

        yield put({ type: FETCH_FETCH_QUICK_CODES_BY_ID_START })
        const response = yield call(fetchQuickCodesbyIdAPI, payload.quickcodeId);

        if (response.success) {
            yield put({ type: FETCH_FETCH_QUICK_CODES_BY_ID_SUCCESS, quickcode: [...response.quickode] })

        } else {
            yield put({ type: FETCH_FETCH_QUICK_CODES_BY_ID_ERROR, error: response.error })
            message.error('Failed to fetch quickcode!');
        }
    }
    catch (error) {
        yield put({ type: FETCH_FETCH_QUICK_CODES_BY_ID_ERROR, error })
        message.error('Failed to fetch quickcode!');
    }
}

function* quickcodesWatcher() {
    yield takeLatest(FETCH_QUICK_CODES, fetchQuickCodes)
    yield takeLatest(ADD_UPDATE_QUICK_CODE, addUpdateQuickCodes)
    yield takeLatest(FETCH_QUICK_CODES_BY_ID, fetchQuickCodesbyId)
}


export default function* rootSaga() {
    yield all([quickcodesWatcher(),])
}